import {Component, effect, input, signal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {Platform} from '../../classes/platform';
import {Checkpoint} from '../../classes/checkpoint';
import {HasFeaturePipe} from '../../pipes/has-feature.pipe';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {UrlPrefixStrippingPipe} from '../../pipes/url-prefix-stripping.pipe';
import {CodaltComponent} from '../../codalt.component';
import {DatePipe} from '@angular/common';
import {SslValidUntilPipe} from '../../pipes/ssl-valid-until.pipe';
import {MsReadablePipe} from '../../pipes/milliseconds-to-readable-time.pipe';
import {DaysFromNowPipe} from '../../pipes/days-from-now.pipe';

@Component({
    selector: 'app-checkpoint-header',
    templateUrl: './checkpoint-header.component.html',
    styleUrls: ['./checkpoint-header.component.scss'],
    imports: [
        RouterLink,
        HasFeaturePipe,
        MatIcon,
        MatIconButton,
        UrlPrefixStrippingPipe,
        DatePipe,
        SslValidUntilPipe,
        MsReadablePipe,
        DaysFromNowPipe
    ]
})
export class CheckpointHeaderComponent extends CodaltComponent {
    platform = input.required<Platform>();
    checkpoint = input.required<Checkpoint>();
    readonly checkpointStatus = signal<string>('');

    constructor() {
        super();
        effect(() => {
            if (this.checkpoint().error) {
                this.checkpointStatus.set('error');
            } else if (this.checkpoint().warning) {
                this.checkpointStatus.set('warning');
            } else {
                const postponedDate = new Date(this.checkpoint()?.postponed_till || '');
                const now = new Date();
                if (postponedDate > now) {
                    this.checkpointStatus.set('alert');
                } else {
                    this.checkpointStatus.set('');
                }
            }
        });
    }
}
